import theme from '../../../lib/theme';
import { ModalProps } from './Modal';

const {
  colors,
  corners,
  layers,
  layouts,
  scale,
  media,
  font: { families },
} = theme;

export default ({ size = 'm' }: ModalProps) => ({
  container: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100vw',
    height: '100vh',
    zIndex: layers.highest,
    fontFamily: families.primary,
    margin: '0px',
    ...layouts.center,

    [media.s.down]: {
      height: '100%',
    },
  },

  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: colors.black,
    opacity: '0.9 !important',
    zIndex: layers.high,
  },

  modalBody: {
    zIndex: layers.highest,
    width: size == 'l' ? '80vw' : size == 'm' ? '60vw' : '40vw',
    maxWidth: '1120px',
    position: 'relative',
    backgroundColor: colors.white,
    borderRadius: `${scale.xs}`,

    [media.m.down]: {
      maxHeight: '95vh',
      height: '95vh',
      width: '90vw',
    },

    [media.s.down]: {
      height: '80%',
    },
  },

  toolbar: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(50%, -50%)',
    zIndex: layers.highest,
  },

  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${scale.xs}`,
    position: 'relative',
    height: '100%',
  },

  modalHeading: {
    flexGrow: 0,
    padding: `${scale.xs} ${scale.s}`,
    borderBottom: `3px solid ${colors.light_grey}`,

    '> h1, > h2, > h3, > h4, > h5, > h6': {
      margin: '0',
      fontWeight: 700,
    },
  },

  childrenContainer: {
    flexGrow: 1,
    padding: `${scale.xs} ${scale.s}`,
    overflowY: 'auto',
    height: '260px',

    [media.m.up]: {
      height: '420px',
    },

    [media.l.up]: {
      height: '480px',
    },
  },

  modalFooter: {
    flexGrow: 0,
    padding: `${scale.xs} ${scale.s}`,
    borderTop: `3px solid ${colors.light_grey}`,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: `${scale.xs}`,
  },

  inner: {
    boxSizing: 'border-box',
    width: '80vw',
    maxWidth: '1120px',
    height: 'auto',
    backgroundColor: colors.white,
    borderRadius: corners.l,
    position: 'relative',
    maxHeight: '80vh',
  },

  backdropInner: {
    ...layouts.center,
    opacity: '1 !important',
    zIndex: layers.higher,

    width: '100%',
    height: '100%',
  },
});
